import { connect } from 'react-redux';
import Landingpage from './landingpage';
import { navigate } from '../reducers/navigator.reducers';

const mapStateToProps = state => ({ 
  loggedIn: state.authentication.loggedIn,
  config: state.authentication.config,
});

const mapDispatchToProps = dispatch => ({
  navigateToLogin: () => dispatch(navigate({route: '/login'})),
  navigateToSignup: () => dispatch(navigate({route: '/signup'})),
});

export default connect(mapStateToProps, mapDispatchToProps)(Landingpage);



// WEBPACK FOOTER //
// ./src/app/landingpage__new/landingpage.container.js